module.exports = __webpack_public_path__ + "img/purple3.2ba8ec75.jpg";